import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "car-search" }
const _hoisted_2 = { class: "lightswitch large" }
const _hoisted_3 = { class: "lightswitch-label" }
const _hoisted_4 = { for: "new" }
const _hoisted_5 = {
  key: 0,
  class: "lightswitch-label"
}
const _hoisted_6 = { for: "used" }
const _hoisted_7 = { class: "form-wrapper" }
const _hoisted_8 = { class: "form-col select-wrapper" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "MAKE", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-col select-wrapper" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "MODEL", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-col range price" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  readOnly: "",
  value: "Price Range"
}, null, -1)
const _hoisted_18 = { class: "slider-wrapper" }
const _hoisted_19 = { class: "form-col range year" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  readOnly: "",
  value: "Year Range"
}, null, -1)
const _hoisted_21 = { class: "slider-wrapper" }
const _hoisted_22 = { class: "form-col select-wrapper" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "MODEL", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form-col has-button" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    "aria-label": "Submit"
  })
], -1)

import { 
		onMounted, 
		ref, 
		reactive, 
		computed 
	} from 'vue';
	import { useStore } from 'vuex';
	import { 
		IStoreState, 
		INewVehicle, 
		IVehicle, 
		IFilterQueryStringParameters, 
		ISearchOption
	} from '@/types';
	import { EStockCategoryId, EFilterQueryStringParameters, ESortOptions } from '@/enums';
	import { toTitleCase } from '@/helpers';
	import VueSlider from 'vue-slider-component';
	import 'vue-slider-component/lib/theme/default.scss';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const store = useStore<IStoreState>();

	const searchTitle = (window as any).uvSearchTitle || '';
	const hasUsedCarsForm: boolean = (window as any).uvHasUsedCarsForm;
	const newVehiclesUrl: string = (window as any).uvDealerNewVehUrl;
	const usedVehiclesUrl: string = (window as any).uvDealerUsedVehUrl;
	const newVehiclesEndpoint: string = (window as any).uvVehiclesEndpoint || '';
	const defaultCondition: EStockCategoryId = (window as any).uvSearchConditionDefault;
	const isNewDefaultCondition: boolean = defaultCondition == EStockCategoryId.new;
	const isUsedDefaultCondition: boolean = defaultCondition == EStockCategoryId.used;
	const excludedNewSearchModels = (window as any).uvExcludedNewSearchModels;
	const priceMin = (window as any).uvFilterInit.PriceMin;
	const priceMax = (window as any).uvFilterInit.PriceMax;
	const yearMin = (window as any).uvFilterInit.YearMin;
	const yearMax = (window as any).uvFilterInit.YearMax;
	const brandId = (window as any).uvBrandId || 1;

	const newVehicles: Array<INewVehicle> = reactive([]);
	const hasRetrievedNewCars = ref(false);
	const hasRetrievedUsedCars = ref(!!store.state.vehicles.length);
	const selectedCondition = ref<EStockCategoryId>(defaultCondition);
	const selectedMake = ref<string>("");
	const selectedModel = ref<string>("");
	const selectedPrice = ref<Array<number>>([priceMin, priceMax]);
	const selectedYear = ref<Array<number>>([yearMin, yearMax]);

	const hasUsedModels = computed(() => !!store.state.vehicles.length);
	const usedCarsClass = computed(() => `used-cars ${selectedCondition.value == EStockCategoryId.used ? 'active' : ''}`);
	const displayUsedMakes = computed((): Array<ISearchOption> => {
		return getUniqueSearchOptionsFromStringArray(store.state.vehicles.map((o: IVehicle) => o.Make.toUpperCase()), true);
	});
	const displayUsedModels = computed((): Array<ISearchOption> => {
		return getUniqueSearchOptionsFromStringArray(store.state.vehicles
			.filter((o: IVehicle) => o.Make.toLowerCase() === selectedMake.value.toLowerCase())
			.map((o: IVehicle) => o.Model
		), true);
	});
	const isUsedModelsDisabled = computed((): boolean => !displayUsedModels.value.length || !selectedMake.value);
	// const isSubmitDisabled = computed((): boolean => !selectedModel.value);
	const usedText = computed(() => (window as any).uvUsedCategoryLabel || '');
	const carText = computed(() => brandId == 5 ? "Tractors & Equipment" : "Cars"  || 'Cars');
	const newCarsClass = computed(() => `new-cars ${selectedCondition.value == EStockCategoryId.new ? 'active' : ''}`);
	const displayNewModels = computed((): Array<ISearchOption> => {
		return getUniqueSearchOptionsFromStringArray(newVehicles
			.map((o: INewVehicle) => o.Model)
			.filter((o: string) => !excludedNewSearchModels.includes(o)
		), true);
	});

	const getUniqueSearchOptionsFromStringArray = (arr: Array<string>, sort: boolean): Array<ISearchOption> => {
		const uniqueArr: Array<string> = [...new Set(arr)];
		if (sort){
			uniqueArr.sort();
		}
		return uniqueArr.map((o: string) => {
			return {
				value: o, 
				text: o
			}
		});
	};
	const handleNewUsedChange = (id: EStockCategoryId): void => {
		selectedCondition.value = id;
		switch (id){
			case EStockCategoryId.new: {
				if (!hasRetrievedNewCars.value){
					getNewVehicles();
				}
				break;
			}
			case EStockCategoryId.used: {
				if (!hasRetrievedUsedCars.value){
					getUsedVehicles();
				}
				break;
			}
		}

	}
	const handleSubmit = ($event: Event): void => {
		$event.preventDefault();
		switch (selectedCondition.value){
			case EStockCategoryId.new: {
				const modelArray: Array<INewVehicle> = newVehicles.filter((o: INewVehicle) => o.Model.toLowerCase() == selectedModel.value.toLowerCase());
				const modelUrl: string = modelArray.length ? modelArray[0].Url : '';
				const url = `${newVehiclesUrl ? newVehiclesUrl : ''}${modelUrl}`;
				(window as any).location = url;
				break;
			}
			case EStockCategoryId.used: {
				const finalPriceMin = selectedPrice.value.length ? selectedPrice.value[0] : priceMin;
				const finalPriceMax = selectedPrice.value.length > 1 ? selectedPrice.value[1] : priceMax;
				const finalYearMin = selectedYear.value.length ? selectedYear.value[0] : yearMin;
				const finalYearMax = selectedYear.value.length > 1 ? selectedYear.value[1] : yearMax;
				const finalMakes = (selectedMake.value ? [selectedMake.value] : [])
					.map((o: string) => o.replace(/\s/g, '+'))
					.join('%2B')
					.toLowerCase()
				;
				const finalModels = (selectedModel.value ? [selectedModel.value] : [])
					.map((o: string) => o.replace(/\s/g, '+'))
					.join('%2B')
					.toLowerCase()
				;

				const queryObj: IFilterQueryStringParameters = {
					[EFilterQueryStringParameters.priceMin]: finalPriceMin,
					[EFilterQueryStringParameters.priceMax]: finalPriceMax,
					[EFilterQueryStringParameters.yearMin]: finalYearMin,
					[EFilterQueryStringParameters.yearMax]: finalYearMax,
					[EFilterQueryStringParameters.locations]: "",
					[EFilterQueryStringParameters.makes]: finalMakes,
					[EFilterQueryStringParameters.certified]: "",
					[EFilterQueryStringParameters.models]: finalModels,
					[EFilterQueryStringParameters.body]: "",
					[EFilterQueryStringParameters.fuel]: "", 
					[EFilterQueryStringParameters.transmission]: "",
					[EFilterQueryStringParameters.sort]: ESortOptions.PriceLowToHigh.toString(),
					[EFilterQueryStringParameters.conditions]: EStockCategoryId.used.toString()
				};

				let qs = '';
				for (const [key, val] of Object.entries(queryObj)){
					qs += `&${key}=${val}`;
				}
				qs.replace('&', '?');

				const url = `${usedVehiclesUrl}?${qs}`;
				(window as any).location = url;
				break;
			}
		}
	}
	const handleMakeChange = ($event: Event): void => {
		selectedMake.value = ($event.target as HTMLInputElement).value;
	}
	const handleModelChange = ($event: Event): void => {
		selectedModel.value = ($event.target as HTMLInputElement).value;
	}
	const getUsedVehicles = (): void => {
		hasRetrievedUsedCars.value = true;
		console.log('bf searchapp getUsed updateVehicles');
		store.dispatch('updateVehicles', { amend: false });
	};
	const getNewVehicles = async (): Promise<void> => {
		hasRetrievedNewCars.value = true;
		store.commit('setIsRetrievingData', true);
		await fetch(newVehiclesEndpoint).then(response => {
			return response.json();
		}).then((json: Array<INewVehicle>) => {
			for (const o of json){
				if (o.Model !== ''){
					newVehicles.push(o);
				}
			}
		}).catch(error => {
			console.log(error);
		});
		store.commit('setIsRetrievingData', false);
	};
	onMounted((): void => {
		if (!hasRetrievedUsedCars.value && hasUsedCarsForm){
			getUsedVehicles();
		}
		if (!hasRetrievedNewCars.value && !hasUsedCarsForm){
			getNewVehicles();
		}
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, [
      _createElementVNode("div", null, _toDisplayString(_unref(searchTitle)), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("input", {
            type: "radio",
            name: "neworused",
            id: "new",
            checked: isNewDefaultCondition,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (handleNewUsedChange(_unref(EStockCategoryId).new)))
          }, null, 32),
          _createElementVNode("label", _hoisted_4, "New " + _toDisplayString(_unref(carText)), 1)
        ]),
        (_unref(hasUsedModels))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("input", {
                type: "radio",
                name: "neworused",
                id: "used",
                checked: isUsedDefaultCondition,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (handleNewUsedChange(_unref(EStockCategoryId).used)))
              }, null, 32),
              _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(usedText)) + " " + _toDisplayString(_unref(carText)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", { onSubmit: handleSubmit }, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(usedCarsClass))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("select", {
              disabled: !_unref(displayUsedMakes).length,
              onChange: handleMakeChange
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayUsedMakes), (m) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: m.value,
                  key: m.value
                }, _toDisplayString(_unref(toTitleCase)(m.text)), 9, _hoisted_11))
              }), 128))
            ], 40, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("select", {
              disabled: _unref(isUsedModelsDisabled),
              onChange: handleModelChange
            }, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayUsedModels), (m) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: m.value,
                  key: m.value
                }, _toDisplayString(m.text), 9, _hoisted_15))
              }), 128))
            ], 40, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_unref(VueSlider), {
                modelValue: selectedPrice.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedPrice).value = $event)),
                min: _unref(priceMin),
                max: _unref(priceMax),
                "min-range": 1000,
                contained: true,
                lazy: true,
                dotSize: [20,20],
                "tooltip-formatter": (val) => `${Math.floor(val / 1000)}K`,
                "tooltip-placement": "bottom",
                tooltip: "always"
              }, null, 8, ["modelValue", "min", "max", "tooltip-formatter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_unref(VueSlider), {
                modelValue: selectedYear.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedYear).value = $event)),
                min: _unref(yearMin),
                max: _unref(yearMax),
                "min-range": 1,
                contained: true,
                lazy: true,
                dotSize: [20,20],
                "tooltip-placement": "bottom",
                tooltip: "always"
              }, null, 8, ["modelValue", "min", "max"])
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(newCarsClass))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("select", { onChange: handleModelChange }, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayNewModels), (m) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: m.value,
                  key: m.value
                }, _toDisplayString(m.text), 9, _hoisted_24))
              }), 128))
            ], 32)
          ])
        ], 2),
        _hoisted_25
      ], 32)
    ])
  ]))
}
}

})